import { applyFormat } from '../../../../utils/strings';
export var waterfallOptions = function (formatOptions) { return ({
    plugins: {
        tooltip: {
            displayColors: false,
            callbacks: {
                label: function (ctx) {
                    var dataIndex = ctx.dataIndex, chart = ctx.chart;
                    var formatter = formatOptions.formatter;
                    var _a = chart.data.datasets, firstDataset = _a[0], secondDataset = _a[1];
                    var firstDatasetValue = firstDataset.data[dataIndex];
                    var secondDatasetValue = secondDataset.data[dataIndex];
                    if (!firstDatasetValue && !secondDatasetValue)
                        return null;
                    var firstLabel = "".concat(firstDataset.label, ": ").concat(applyFormat({
                        formatter: formatter,
                        value: firstDatasetValue,
                    }));
                    var secondLabel = "".concat(secondDataset.label, ": ").concat(applyFormat({
                        formatter: formatter,
                        value: secondDatasetValue,
                    }));
                    return [firstLabel, secondLabel];
                },
                footer: function (tooltipItems) {
                    var tooltip = tooltipItems[0];
                    var formatter = formatOptions.formatter;
                    var _a = tooltip.raw, firstValue = _a[0], secondValue = _a[1];
                    var result = Math.abs(secondValue - firstValue);
                    return "Difference: ".concat(applyFormat({ formatter: formatter, value: result }));
                },
            },
        },
    },
}); };
